import type { FaireProductEntity } from "../../entity_types/product";

export const p_zufsue5q73: FaireProductEntity = {
  token: "p_zufsue5q73",
  type: "product",
  name: "Sunflower Tile Design",
  brandToken: "b_xefwj7gp89",
  brandName: "Saturn Press",
  imageUrl:
    "https://cdn.faire.com/fastly/350db3eac55ded8b2aac4b0440646f503ad18c44e1c8c90f3fe9a95e45c19192.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c06aab69aba18c7b6f9a1824ae19e64dde4f780b2cd6c6fce4bb46bc9d0e21cc.jpeg",
    "https://cdn.faire.com/fastly/a9977e6845adc986a1f48a15a7614cf3f9854e053f8012080ddbe0d40c9e6199.jpeg",
  ],
  priceDollars: 3,
  description:
    "After William de Morgan circa 1885 Great Britain. Letterpress printed. Deckle edged paper. Includes matching envelope. Available sleeved or unsleeved.\n\nBold golden sunflowers in sophisticated Arts & Crafts style, printed with rich letterpress inks on luxury paper. Deep impression printing creates tactile luxury with multi-tonal yellows and earth tones.\n\nUniversal sunflower appeal works for congratulations, thank you, encouragement, friendship, or brightening someone's day.\n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:55.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
